<template>
  <div>
    <transition name="fade" mode="out-in" :duration="300">
      <template v-if="showQuestion">
        <section class="section section-lg">
          <question :radioAnswer="answer" @answerWasChanged="answer = $event">
            <h5 slot="title" class="card-title text-muted">
              <div v-if="timer" style="float: right; position: relative; top: -20">
                <BaseTimer v-bind:time_limit_s="timer" v-on:time-up="timeup()"/>
              </div>
              {{translate(getLanguage(), "Questão")}}
              {{questionNumber}}
              / {{lenQuestions}}
            </h5>

            <div slot="body" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              <Markdown :markdown="body" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent></Markdown>
            </div>

            <p slot="answer1" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              {{answerText1}}
            </p>
            <p slot="answer2" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              {{answerText2}}
            </p>
            <p slot="answer3" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              {{answerText3}}
            </p>
            <p slot="answer4" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              {{answerText4}}
            </p>
            <p slot="answer5" @click.right.prevent @keydown="keydownBlock" @copy.prevent @paste.prevent>
              {{translate(getLanguage(), answerText5)}}
            </p>


            <base-button slot="button" @click="submitQuestion" type="primary" size="lg" class="align-center">
              <div class="px-5">
                <i style="color: white" class="fa fa-check-circle"></i>
                <span class="btn-inner--text">
                  {{translate(getLanguage(), "Confirme a resposta")}}
                </span>
              </div>
            </base-button >
          </question>
        </section>
      </template>
    </transition>
  </div>
</template>

<script>
import translate from "../i18n/i18n.js";
import Question from "./components/Question";
import Markdown from './components/Markdown';
import BaseTimer from './components/BaseTimer';
import router from '../router';
export default {
  data: () => ({
    showQuestion: true,
    body: "",
    answer: "4",
    answerText1: "",
    answerText2: "",
    answerText3: "",
    answerText4: "",
    answerText5: "",
    first: true,
    firstID: 0,
    lastQuestionID: 0,
    currentQuestionID: 0,
    nextQuestionID: 0,
    questionNumber: 0,
    timer: 0,
    lenQuestions: 0,
  }),
  methods: {
    getLanguage(){
      return localStorage.getItem('language') || 0;
    },
    translate: function(language, phrase){
      return translate(language, phrase);
    },
    keydownBlock: () => {},
    timeup: function() {
      console.log('TIME IS UP!');
      this.answer = "4";
      this.submitQuestion();
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async submitQuestion() {
      if (parseInt(this.answer) > 4 || parseInt(this.answer < 0)){
        return
      }
      this.showQuestion = false;
      await this.sleep(160);
      const urlAnswer = process.env.VUE_APP_API_URL + "/resource/question-current";
      const urlNext = process.env.VUE_APP_API_URL + "/resource/question-next";
      const urlReport = process.env.VUE_APP_API_URL + "/resource/report";

      let simpleAnswer = {
        QuestionID: parseInt(this.currentQuestionID),
        Answer: parseInt(this.answer)
      };

      console.log('fetch=', urlAnswer)
      fetch(urlAnswer, {
        method: "PUT", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          "Content-Language": this.getLanguage(),
          "Authorization": "Bearer " + this.$store.getters.token
        },
        body: JSON.stringify(simpleAnswer) // body data type must match "Content-Type" header
      })
        .then(res => {
          if (res.status == 404){
            return {
              "outOfBounds": true,
              "ID": this.currentQuestionID,
              "Question" : {
                "Body": this.body,
                "Answers": {
                  "0": this.answerText1, 
                  "1": this.answerText2, 
                  "2": this.answerText3, 
                  "3": this.answerText4, 
                  "4": this.answerText5, 
                }
              }
            }
          } else if (res.status == 200){
            return res.json()
          } else {
            // TODO: tratar erros
            return res.json()
          }
        })
        .then(res=> {
          console.log("response from put:")
          console.log(res)
          // TODO: tratar erros
        }).then( () => {
          console.log('fetch=', urlNext)
          return fetch(urlNext, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "Content-Language": this.getLanguage(),
              "Authorization": "Bearer " + this.$store.getters.token
            }});
        }).then(res => res.json())
        .then(res => {
          console.log("response from next:")
          console.log(res)
          // console.log("last: " + this.lastQuestionID + " current: " + this.currentQuestionID + " next: " + res["ID"])
          this.lastQuestionID = this.currentQuestionID;
          if(this.currentQuestionID == res["ID"]){
            console.log('fetch=', urlReport)
            return fetch(urlReport, {
              method: "GET",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/json",
                "Content-Language": this.getLanguage(),
                "Authorization": "Bearer " + this.$store.getters.token
              }});
          } else {
            this.body = res["Question"]["Body"];
            this.answerText1 = res["Question"]["Answers"]["0"];
            this.answerText2 = res["Question"]["Answers"]["1"];
            this.answerText3 = res["Question"]["Answers"]["2"];
            this.answerText4 = res["Question"]["Answers"]["3"];
            this.answerText5 = "Não sei.";
            this.currentQuestionID = res["ID"];
            this.questionNumber = res["CurrentQuestionIndex"] + 1;
            this.showQuestion = true;
            return null;
          }
        }).then(res => {
          if(res){
            return res.json()
          } else {
            return null
          }
        }).then( res =>{
            if (res) {
              // TODO hack
              const userData = this.$store.getters.user;
              userData.CurrentQuestion = -1;
              this.$store.dispatch('setUser', userData);
              //

              console.log("response from report: ");
              console.log(res);
              localStorage.setItem('currentScore', res["Score"]+"/"+res["Len"]);
              localStorage.setItem('tagsCount', JSON.stringify(res["TagCount"]));
              localStorage.setItem('bestSubject', res["BestSubject"]);
              localStorage.setItem('worstSubject', res["WorstSubject"]);

              router.push("/report");
            }
        });
        this.answer = "99";
    }
  },
  created: async function () {
      this.showQuestion = true;

      const url = process.env.VUE_APP_API_URL + "/resource/question-current";
      console.log('fetch=', url);
      fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          "Content-Language": this.getLanguage(),
          "Authorization": "Bearer " + this.$store.getters.token,
        },
      })
        .then(res => res.json())
        .then(data => {
          const userQuestion = data;
          console.log(data);

          if (userQuestion) {
            this.timer = 60*2;
            //console.log(question);
            this.body = userQuestion["Question"]["Body"];
            this.answerText1 = userQuestion["Question"]["Answers"]["0"];
            this.answerText2 = userQuestion["Question"]["Answers"]["1"];
            this.answerText3 = userQuestion["Question"]["Answers"]["2"];
            this.answerText4 = userQuestion["Question"]["Answers"]["3"];
            this.answerText5 = "Não sei.";
            if (this.first == true){
              this.firstID = userQuestion["ID"];
              this.first = false;
            }
            this.currentQuestionID = userQuestion["ID"];
            this.questionNumber = userQuestion["CurrentQuestionIndex"] + 1
            this.lastQuestionID = -1;
            this.lenQuestions = userQuestion["LenUserQuestions"];
          }
        });

  },
  components: {
    question: Question,
    Markdown,
    BaseTimer,
  },
};
</script>
<style>
  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 160ms;

  }

  .fade-leave-active {
    transition: opacity 1s;
    opacity: 0;
  }

</style>

